export const SECURITY_USER_DEFAULTS_DATA = {
    jti: '',
    exp: 0,
    nbf: 0,
    iat: 0,
    iss: '',
    aud: '',
    sub: '',
    typ: '',
    azp: '',
    nonce: '',
    auth_time: 0,
    session_state: '',
    acr: '',
    'allowed-origins': [],
    realm_access: {
        roles: [],
    },
    resource_access: {
        account: {
            roles: [],
        },
    },
    scope: '',
    name: '',
    groups: [],
    preferred_username: '',
    given_name: '',
    family_name: '',
    email: '',
};

export const SECURITY_DEFAULTS_DATA = {
    isLogged: true,
    isLoading: false,
    isFailed: false,
    user: SECURITY_USER_DEFAULTS_DATA,
    accountUrl: '',
};
